import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import { ShowHide } from "./concerns/showHide";
import { get, patch } from '@rails/request.js'
import _ from "underscore"

export default class extends Controller {

  static targets = [
    "name",
    "allFieldsContainer", "newFieldsContainer", "intervalName",
    "searchResults", "searchingMessage", "pickedAsana",
    "photoInput", "photoPreview", "photoStatus"]

  initialize() {
    Loggable(this, { debug: false })
    ShowHide(this)

    this.searchAsanas = _.debounce(this.searchAsanas.bind(this), 300)
  }
  connect() {
    this.log("connected")
  }

  disconnect() {
    this.searchAsanas.cancel()
    this.releasePhotoPreview()
  }

  copyData() {
    if (!this.isHidden(this.allFieldsContainerTarget)) {
      if (this.intervalNameTarget.value != "" && this.intervalNameTarget.value != this.nameTarget.value){
        this.nameTarget.value = this.intervalNameTarget.value
        this.searchAsanas()
      }
    }
  }

  pick(event) {
    this.log("picked asana")
    this.clearPendingPhoto()
    this.originalPhotoSource = null
    this.searchResultsTarget.innerHTML = ""
    // tengo event.params.pickedId
    patch(`/timer/asanas/${event.params.pickedId}/pick`, {
      query: {
        interval_id: this.nameTarget.value
      },
      responseKind: "turbo-stream"
    })

    this.nameTarget.value = ""
    this.hide(this.allFieldsContainerTarget)
  }

  // mostrar form para crear un nuevo
  ignoreResults(event) {
    this.clearPendingPhoto()
    this.originalPhotoSource = null
    this.searchResultsTarget.innerHTML = ""
    this.show(this.newFieldsContainerTarget)
  }

  clearPick(event) {
    this.clearPendingPhoto()
    this.originalPhotoSource = null
    this.pickedAsanaTarget.innerHTML = ""
    this.show(this.allFieldsContainerTarget)
  }

  choosePhoto() {
    this.photoInputTarget.click()
  }

  previewPhoto() {
    const file = this.photoInputTarget.files[0]
    if (!file || !this.hasPhotoPreviewTarget) return

    this.originalPhotoSource ||= this.photoPreviewTarget.getAttribute("src")
    this.releasePhotoPreview()
    this.photoPreviewUrl = URL.createObjectURL(file)
    this.photoPreviewTarget.src = this.photoPreviewUrl
    if (this.hasPhotoStatusTarget) this.show(this.photoStatusTarget)
  }

  clearPendingPhoto() {
    if (this.hasPhotoInputTarget) this.photoInputTarget.value = ""
    if (this.hasPhotoPreviewTarget && this.originalPhotoSource) {
      this.photoPreviewTarget.setAttribute("src", this.originalPhotoSource)
    }
    if (this.hasPhotoStatusTarget) this.hide(this.photoStatusTarget)
    this.releasePhotoPreview()
  }

  releasePhotoPreview() {
    if (!this.photoPreviewUrl) return

    URL.revokeObjectURL(this.photoPreviewUrl)
    this.photoPreviewUrl = null
  }

  searchAsanas() {
    this.log("searching asanas...")
    this.hide(this.newFieldsContainerTarget)
    this.show(this.searchingMessageTarget)
    get("/timer/asanas", {
      query: {
        q: this.nameTarget.value
      },
      responseKind: "turbo-stream"
    })
  }

}
